import { Observable } from 'rxjs';
import { APIResponseWrapper } from '../../models/common/api-response-wrapper';
import * as HrModels from '../hr.models';
import { Constructor, HrApiClient } from '../shared/hr-api-client';

export function withHrEmployeeApi<TBase extends Constructor<HrApiClient>>(Base: TBase) {
  return class extends Base {
    employees(filters: HrModels.HrEmployeeFilters = {}): Observable<HrModels.HrApiList<HrModels.HrEmployee>> {
        return this.http.get<HrModels.HrApiList<HrModels.HrEmployee>>(`${this.baseUrl}/employees`, {
          params: this.params(filters)
        });
      }
    
    employee(employeeId: number, owningCompanyId?: number): Observable<APIResponseWrapper<HrModels.HrEmployee>> {
        return this.http.get<APIResponseWrapper<HrModels.HrEmployee>>(`${this.baseUrl}/employees/${employeeId}`, {
          params: this.params({ owningCompanyId })
        });
      }
    
    createEmployee(request: HrModels.HrEmployee): Observable<APIResponseWrapper<HrModels.HrEmployee>> {
        return this.http.post<APIResponseWrapper<HrModels.HrEmployee>>(`${this.baseUrl}/employees`, request);
      }
    
    updateEmployee(employeeId: number, request: HrModels.HrEmployee): Observable<APIResponseWrapper<HrModels.HrEmployee>> {
        return this.http.put<APIResponseWrapper<HrModels.HrEmployee>>(`${this.baseUrl}/employees/${employeeId}`, request);
      }
    
    changeStatus(employeeId: number, status: string, reason?: string, owningCompanyId?: number): Observable<APIResponseWrapper<HrModels.HrEmployee>> {
        return this.http.post<APIResponseWrapper<HrModels.HrEmployee>>(`${this.baseUrl}/employees/${employeeId}/status`, { status, reason }, {
          params: this.params({ owningCompanyId })
        });
      }
    
    linkCustomer(employeeId: number, linkedEntityId: number, owningCompanyId?: number): Observable<APIResponseWrapper<HrModels.HrEmployee>> {
        return this.http.post<APIResponseWrapper<HrModels.HrEmployee>>(`${this.baseUrl}/employees/${employeeId}/links/customer`, { linkedEntityId }, {
          params: this.params({ owningCompanyId })
        });
      }
    
    linkDriver(employeeId: number, linkedEntityId: number, owningCompanyId?: number): Observable<APIResponseWrapper<HrModels.HrEmployee>> {
        return this.http.post<APIResponseWrapper<HrModels.HrEmployee>>(`${this.baseUrl}/employees/${employeeId}/links/driver`, { linkedEntityId }, {
          params: this.params({ owningCompanyId })
        });
      }
    
    unlinkIdentity(employeeId: number, linkType: string, owningCompanyId?: number): Observable<APIResponseWrapper<HrModels.HrEmployee>> {
        return this.http.delete<APIResponseWrapper<HrModels.HrEmployee>>(`${this.baseUrl}/employees/${employeeId}/links/${linkType}`, {
          params: this.params({ owningCompanyId })
        });
      }
  };
}

